<template>
  <b-table
    :data="results"
    paginated
    backend-pagination
    @page-change="onPageChange"
    :total="total"
    :per-page="pageSize"
    :show-detail-icon="true"
    detailed
    detail-key="id"
    hoverable
    :sort-icon="sortIcon"
    :sort-icon-size="sortIconSize"
    :default-sort-direction="defaultSortOrder"
    :default-sort="[sortField, sortOrder]"
    backend-sorting
    @sort="onSort"
  >
    <template slot-scope="props">
      <b-table-column class="is-hidden-mobile">
        <figure class="image is-96x96">
          <img
            :src="
              `https://assets.urlaubsgutschein.kaufen/i/resize?width=128&quality=50&file=${props.row.image}`
            "
            :alt="props.row.contact.name"
            loading="lazy"
            class="is-rounded"
          />
        </figure>
      </b-table-column>
      <b-table-column label="Hotel" field="contacts[0].contact.name" sortable>
        <p>
          {{ props.row.contact.name }}<br />
          <small
            >({{ props.row.contact.country }}-{{ props.row.contact.zip }}
            {{ props.row.contact.city }})
          </small>
        </p>
      </b-table-column>

      <b-table-column label="Titel" field="title" sortable>
        <p>
          {{ props.row.title }}
          <br />
          <small>{{ props.row.subtitle }}</small>
        </p>
      </b-table-column>

      <b-table-column field="onlineTo" label="Online bis" sortable>
        {{ props.row.onlineTo | formatDate }}
      </b-table-column>
      <b-table-column
        label="Verbleibend"
        class="has-text-centered"
        field="variants.reduce((a, c) => a + c.available, 0)"
        sortable
      >
        <b-tag
          size="is-medium"
          v-bind:class="{
            'is-danger':
              props.row.variants.reduce((a, c) => a + c.available, 0) === 0,
            'is-warning':
              props.row.variants.reduce((a, c) => a + c.available, 0) < 20,
          }"
        >
          {{ props.row.variants.reduce((a, c) => a + c.available, 0) }}
        </b-tag>
      </b-table-column>
    </template>
    <template slot="detail" slot-scope="props">
      <div class="content">
        <h3>Anmerkungen</h3>
        <div v-if="props.row.internal">
          <pre>{{ props.row.internal.notes }}</pre>
        </div>
        <!-- <div v-if="!props.row.internal">
                <i>Keine internen Anmerkungen und Details zu diesem Angebot.</i>
              </div> -->

        <b-notification
          type="is-info"
          v-if="!props.row.internal"
          :closable="false"
          class="has-text-weight-bold"
        >
          <b-icon icon="info-circle" size="is-small"> </b-icon>
          Keine internen Anmerkungen und Details zu diesem Angebot.
        </b-notification>

        <hr />
        <h3>Varianten</h3>

        <div class="columns is-multiline">
          <div
            class="column is-4-desktop is-6-tablet"
            v-for="item in props.row.variants"
            :key="item.id"
          >
            <div class="box">
              <strong>Nächte:</strong> {{ item.nights }} <br />
              <strong>Personen:</strong> {{ item.persons }} <br />
              <strong>Verpflegung:</strong> {{ item.board.longName }}
              <br />
              <strong>Verbleibend: </strong>
              <b-tag
                v-bind:class="{
                  'is-danger': item.available === 0,
                  'is-warning': item.available < 20,
                }"
                >{{ item.available }} Stk.</b-tag
              >
              <br />
              <p class="is-size-4 has-text-right">
                <strong>Preis:</strong>
                {{ item.price.currency | currency }}
                {{ item.price.total | amount }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"> </b-icon>
          </p>
          <p>Leider keine Angebote verfügbar.</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
export default {
  name: 'OffersTable',
  props: {
    results: Array,
    page: Number,
    pageSize: Number,
    total: Number,
    sortOrder: String,
    sortField: String,
  },
  data() {
    return {
      defaultSortOrder: 'asc',
      sortIcon: 'arrow-up',
      sortIconSize: 'is-small',
    }
  },
  methods: {
    onPageChange(p) {
      this.$emit('request-page', p)
    },
    onSort(field, order) {
      this.$emit('request-sort', field, order)
    },
  },
}
</script>

<style lang="scss">
.detail {
  background-color: hsl(0, 0%, 98%) !important;
}
</style>
